<template>
  <div class="faq-item">
    <strong>{{ category }}</strong>

    <ul class="accordion-ui">
      <AccordionFaq v-for="(qna, qnaIndex) in qnaList" :key="`qna_${qnaIndex}`">
        <template #header>
          <p>{{ t(qna.question) }}</p>
        </template>

        <span v-for="(answer, answerIndex) in qna.answer" :key="`answer_${answerIndex}`">
          {{ t(answer) + ' ' }}
        </span>
      </AccordionFaq>
    </ul>
  </div>
</template>

<script setup lang="ts">
import AccordionFaq from '@/components/domains/mobile/user-manage/AccordionFaq.vue';
import { QnaItem } from '@/types/components';

withDefaults(
  defineProps<{
    category: string;
    qnaList: QnaItem[];
  }>(),
  {
    category: '',
    qnaList: () => [],
  }
);

const { t } = useI18n();
</script>

<style scoped lang="scss">
.faq-item {
  margin-top: 2.5rem;

  strong {
    display: block;
    font-size: 1rem;
    font-weight: 600;
    padding-bottom: $size-m;
  }

  .accordion-ui {
    span {
      font-size: $font-size-psmall;
      line-height: 140%;
    }
  }
}
</style>
